import React from 'react';

export interface RetailersSummaryProps {
    retailerIds: string[];
    retailerNameById: Record<string, string>;
}

const RetailersSummary: React.FC<RetailersSummaryProps> = ({ retailerIds, retailerNameById }) => {

    return (
        <div style={{ width: '100%' }}>
            <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>Retailers</div>
            <div style={{ color: '#031425', fontSize: 14, width: '100%', marginBottom: 12, fontWeight: 400 }}>
                Stackline can collect pricing data from any e-commerce retailer that has reliable data. We maintain 5,000+ of the
                world’s largest retailers across every country. Your product URLs will automatically match against Stackline’s list.
                If we don’t cover your retailer, reach out to have it added.
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {retailerIds.map((retailerId) => (
                    <div
                        key={retailerId}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            background: '#E7F5EE',
                            color: '#052849',
                            border: '1px solid #C6EBD8',
                            borderRadius: 16,
                            padding: '6px 10px',
                            fontSize: 12,
                            fontWeight: 400
                        }}
                    >
                        {retailerNameById[String(retailerId)] || retailerId}
                    </div>
                ))
                }
            </div>
        </div>
    );
};

export default RetailersSummary;
